import { render, staticRenderFns } from "./EmployeeAdmin.vue?vue&type=template&id=789df8cb"
import script from "./EmployeeAdmin.vue?vue&type=script&lang=js"
export * from "./EmployeeAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports